import { render, staticRenderFns } from "./SummaryPriceRedesign.vue?vue&type=template&id=0ba045af&scoped=true&"
import script from "./SummaryPriceRedesign.vue?vue&type=script&lang=ts&"
export * from "./SummaryPriceRedesign.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryPriceRedesign.vue?vue&type=style&index=0&id=0ba045af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba045af",
  null
  
)

export default component.exports